(function ($) {
  Drupal.behaviors.aaaFEPartialDemoV1 = {
    attach: function (context, settings) {
      var $tmpl = $('.aaa-fe-partial-demo-v1'),
        title = $tmpl.find('.hidden .title').html(),
        content = $tmpl.find('.hidden .content').html(),
        $out = $tmpl.find('.output');

      $tmpl.find('.clicker a').on('click', function(e) {
        e.preventDefault();
        $out.show();

        Drupal.cl.template.get({
          path: 'fe_partial_demo',
          object: {
            title: title,
            content: content
          },
          callback: function (out, data) {
            $out.html(out);
          },
          partials: {
            include_me: 'fe_partial_demo_inc'
          }
        });
      });
    }
  };
})(jQuery);
